(function () {
  const initProductAccordion = () => {
    const aboutToggleItems = $(".about__accordion-toggle");

    aboutToggleItems.each(function() {
      const currentToggle = $(this);
      const siblingToggles = currentToggle.siblings(".about__accordion-description");

      currentToggle.click(function () {
        if (!currentToggle.hasClass("active")) {
          aboutToggleItems.each(function () {
            const siblingToggle = $(this);
            siblingToggle.removeClass("active");
            siblingToggle.siblings(".about__accordion-description").stop().slideUp(300);
          });

          currentToggle.addClass("active");

          siblingToggles.stop().slideDown(300);
        } else {
          currentToggle.removeClass("active");
          siblingToggles.stop().slideUp(300);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(".product-media-modal__content");
    const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  const formatFreeShippingAmount = (value) => {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = theme.moneyFormat;

    return formatString.replace(placeholderRegex, value);
  }

  const setTotalFreeShipping = () => {
    if (document.querySelector('.js-free-shipping')) {
      const freeShippingTotal = document.querySelector('.free-shipping-total');
      if (freeShippingTotal) {
        const minSpend = Number(freeShippingTotal.dataset.minSpend);
        if (minSpend && minSpend > 0) {
          freeShippingTotal.innerText = `${formatFreeShippingAmount(Math.round(minSpend * (Shopify.currency.rate || 1)))}`;
        }
      }
    }
  }

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    setTotalFreeShipping();
  });

  initProductAccordion();
  initZoomImage();
  setTotalFreeShipping();
})();







document.addEventListener('DOMContentLoaded', function () {
  const descriptionContainer = document.getElementById('variant-description-container');
  const fallbackDescription = document.querySelector('[data-product-description]');
  const variantDescriptionsJSON = document.getElementById('variantDescriptionsJSON');

  if (!descriptionContainer || !variantDescriptionsJSON) return;

  let variantDescriptions;

  try {
    variantDescriptions = JSON.parse(variantDescriptionsJSON.textContent);
  } catch (e) {
    console.error('Error parsing variant descriptions JSON:', e);
    return;
  }

  // If your variant descriptions contain HTML tags like <strong>, <br>, 
  // you can insert them directly without decoding HTML entities.
  function updateDescription(variantId) {
  const html = variantDescriptions[variantId];
  const variantBox = document.getElementById('variant-desc-box');

  if (!variantBox) return;

  if (html) {
    variantBox.innerHTML = html;  // Insert variant-specific HTML
  } else {
    variantBox.innerHTML = ''; // No variant description; clear it
  }
}


  // Handle select dropdowns
  const variantSelect = document.querySelector('select[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      updateDescription(this.value);
    });

    // Always show first variant on load
    const firstVariantId = variantSelect.options[0]?.value;
    if (firstVariantId) updateDescription(firstVariantId);
  }

  // Handle radio buttons
  const variantRadios = document.querySelectorAll('input[name="id"]');
  if (variantRadios.length > 0) {
    let selected = false;

    variantRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        updateDescription(this.value);
      });

      if (radio.checked) {
        updateDescription(radio.value);
        selected = true;
      }
    });

    // If no radio is pre-selected, show the first variant
    if (!selected) {
      updateDescription(variantRadios[0].value);
    }
  }
});
